import { render, staticRenderFns } from "./AddIssuanceAndVoucher.vue?vue&type=template&id=3f011060&scoped=true&"
import script from "./AddIssuanceAndVoucher.vue?vue&type=script&lang=js&"
export * from "./AddIssuanceAndVoucher.vue?vue&type=script&lang=js&"
import style0 from "./AddIssuanceAndVoucher.vue?vue&type=style&index=0&id=3f011060&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f011060",
  null
  
)

export default component.exports